"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var ExpandMore_1 = __importDefault(require("@mui/icons-material/ExpandMore"));
var trans_1 = __importDefault(require("@/plugins/trans"));
var html_react_parser_1 = __importDefault(require("html-react-parser"));
var BookmarkedContext_1 = __importDefault(require("../context/BookmarkedContext"));
var ApplyShare_1 = require("./components/ApplyShare");
var useIsSmallScreen_1 = __importDefault(require("../hooks/useIsSmallScreen"));
var ApplyVacancyContext_1 = __importDefault(require("../context/ApplyVacancyContext"));
var classes = {
    spec: {
        px: 4,
        py: 2,
        color: 'secondary.main',
        borderRadius: '10px',
        bgcolor: '#F4F2F4',
        flex: 1,
        flexBasis: 0,
        whiteSpace: 'nowrap',
        textAlign: 'center',
    },
    button: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'secondary.main',
        py: 3,
        px: 7,
        color: 'white',
        borderRadius: '50px',
        height: 'max-content',
        cursor: 'pointer',
    },
    organizationLogo: {
        width: 45,
        height: 45,
        '& > img': {
            objectFit: 'contain',
        },
    },
    spacing: {
        px: { xs: 4, lg: 8 },
        py: 4,
    },
    separateBottom: {
        borderBottom: '1px solid',
        borderColor: 'primary.main',
    },
    loadMoreButton: {
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: '-20px',
        cursor: 'pointer',
        width: 'max-content',
        backgroundColor: '#F4F2F4',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        px: 4,
        paddingRight: '2.5rem',
        py: 2,
        mx: 'auto',
        border: '1px solid',
        borderColor: 'primary.main',
        borderRadius: '50px',
    },
};
var SelectedVacancy = function (_a) {
    var _b, _c, _d;
    var vacancy = _a.vacancy, _e = _a.suggested, suggested = _e === void 0 ? false : _e;
    var _f = (0, react_1.useContext)(BookmarkedContext_1.default), isLiked = _f.isLiked, handleToggleBookmark = _f.handleToggleBookmark;
    var isSmallScreen = (0, useIsSmallScreen_1.default)();
    var _g = (0, react_1.useContext)(ApplyVacancyContext_1.default), openApplyVacancy = _g.openApplyVacancy, handleOpenApplyVacancy = _g.handleOpenApplyVacancy;
    var _h = (0, react_1.useState)(false), shouldExpand = _h[0], setShouldExpand = _h[1];
    var handleLike = (0, react_1.useCallback)(function () {
        handleToggleBookmark(vacancy === null || vacancy === void 0 ? void 0 : vacancy.id);
    }, [vacancy === null || vacancy === void 0 ? void 0 : vacancy.id, handleToggleBookmark]);
    var expand = (0, react_1.useCallback)(function () {
        setShouldExpand(function (prev) { return !prev; });
    }, []);
    var renderEducationalLevel = function (theVacancy) {
        var minimumEducationalLevel = theVacancy.minimumEducationalLevel, maximumEducationalLevel = theVacancy.maximumEducationalLevel;
        if (minimumEducationalLevel.id !== maximumEducationalLevel.id && !isSmallScreen) {
            return "".concat(minimumEducationalLevel.name, " - ").concat(maximumEducationalLevel.name);
        }
        return minimumEducationalLevel.name;
    };
    var renderHoursPerWeek = function (theVacancy) {
        var minimumHours = theVacancy.minimumHours, maximumHours = theVacancy.maximumHours;
        if (minimumHours !== maximumHours) {
            return "".concat(minimumHours, " - ").concat(maximumHours);
        }
        return minimumHours;
    };
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: {
            border: '1px solid',
            borderColor: 'primary.main',
            borderRadius: '5px',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            boxShadow: '0px 5px 35px 0px #0003411A',
            backgroundColor: 'white',
        } }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    borderBottom: '1px solid',
                    borderColor: 'primary.main',
                } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: classes.spacing }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "h5", color: "secondary", sx: { fontSize: 32, fontWeight: 'bold', wordBreak: 'break-word' } }, { children: (0, html_react_parser_1.default)(vacancy.title) })) })), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: __assign(__assign({}, classes.spacing), { borderLeft: '1px solid', borderColor: 'primary.main', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: { xs: 'column', lg: 'row' } }) }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: { height: 32, width: 32, cursor: 'pointer' }, onClick: handleLike }, { children: isLiked(vacancy.id) ? (0, jsx_runtime_1.jsx)("img", { src: "/img/icons/heart-filled.svg" }) : (0, jsx_runtime_1.jsx)("img", { src: "/img/icons/heart.svg" }) })), (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ sx: { ml: { lg: 2 }, mt: { xs: 2, lg: 0 } } }, { children: trans_1.default.get('buttons.frontend.vacancy.save') }))] }))] })), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: __assign(__assign({ display: 'flex', alignItems: { lg: 'center' }, justifyContent: { xs: 'center', lg: 'initial' }, flexDirection: { xs: 'column', lg: 'row' } }, classes.spacing), classes.separateBottom) }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: { display: 'flex', alignItems: 'center' } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Avatar, { variant: "square", src: (_b = vacancy.organization) === null || _b === void 0 ? void 0 : _b.logo, alt: (_c = vacancy.organization) === null || _c === void 0 ? void 0 : _c.name, sx: classes.organizationLogo }), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: { display: 'flex', flexDirection: 'column', ml: 2, whiteSpace: { xs: 'initial', md: 'nowrap' } } }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Typography, { children: [(_d = vacancy.organization) === null || _d === void 0 ? void 0 : _d.name, " | ", vacancy.locationAddress] }), (0, jsx_runtime_1.jsx)(material_1.Typography, { children: vacancy.salary })] }))] })), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: { display: 'flex', alignItems: 'center', ml: { lg: 8 }, mt: { xs: 4, lg: 0 }, '&>*+*': { ml: 3 } } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: classes.spec }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, { children: "".concat(renderHoursPerWeek(vacancy), " uur") }) })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: classes.spec }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, { children: renderEducationalLevel(vacancy) }) })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: classes.spec }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, { children: vacancy.contractType }) }))] }))] })), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: __assign({}, classes.spacing) }, { children: [(0, jsx_runtime_1.jsx)(ApplyShare_1.ApplyShare, { vacancyId: vacancy.id }), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: { mt: 4 } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "h5", color: "secondary", sx: { fontWeight: 'bold' } }, { children: trans_1.default.get('labels.frontend.vacancy.about') })), (0, jsx_runtime_1.jsx)(material_1.Collapse, __assign({ in: shouldExpand, collapsedSize: 140 }, { children: (0, jsx_runtime_1.jsx)("div", { style: { wordBreak: 'break-word' }, dangerouslySetInnerHTML: { __html: vacancy.text } }) }))] }))] })), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: classes.loadMoreButton, onClick: expand }, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "body1" }, { children: shouldExpand ? trans_1.default.get('labels.general.show_less') : trans_1.default.get('labels.general.show_more') })), (0, jsx_runtime_1.jsx)(ExpandMore_1.default, { sx: {
                            color: 'primary.main',
                            position: 'absolute',
                            right: '4px',
                            fontSize: '2.5rem',
                            transition: 'transform 0.5s ease-in-out',
                            transform: shouldExpand ? 'rotate(-180deg)' : 'none',
                        } })] }))] })));
};
exports.default = SelectedVacancy;
